"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require("babel-runtime/helpers/get");

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _accordion = require("@alicd/next/lib/accordion");

var _accordion2 = _interopRequireDefault(_accordion);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// const Panel = Accordion.Panel;

var AccordionMonkey = function (_Accordion2) {
    (0, _inherits3.default)(AccordionMonkey, _Accordion2);

    function AccordionMonkey() {
        (0, _classCallCheck3.default)(this, AccordionMonkey);
        return (0, _possibleConstructorReturn3.default)(this, (AccordionMonkey.__proto__ || (0, _getPrototypeOf2.default)(AccordionMonkey)).apply(this, arguments));
    }

    (0, _createClass3.default)(AccordionMonkey, [{
        key: "render",
        value: function render() {
            var org = (0, _get3.default)(AccordionMonkey.prototype.__proto__ || (0, _getPrototypeOf2.default)(AccordionMonkey.prototype), "render", this).call(this);
            return _react2.default.cloneElement(org, {}, _react2.default.Children.map(org.props.children, function (item) {
                var Section = item.type;
                var _item$props = item.props,
                    extra = _item$props.extra,
                    _titleOrg = _item$props._titleOrg,
                    rest = (0, _objectWithoutProperties3.default)(_item$props, ["extra", "_titleOrg"]);

                return _react2.default.createElement(
                    Section,
                    rest,
                    item.props.children
                );
            }));
        }
    }]);
    return AccordionMonkey;
}(_accordion2.default);

var Panel = function (_React$Component) {
    (0, _inherits3.default)(Panel, _React$Component);

    function Panel() {
        (0, _classCallCheck3.default)(this, Panel);
        return (0, _possibleConstructorReturn3.default)(this, (Panel.__proto__ || (0, _getPrototypeOf2.default)(Panel)).apply(this, arguments));
    }

    (0, _createClass3.default)(Panel, [{
        key: "render",
        value: function render() {
            return null;
        }
    }]);
    return Panel;
}(_react2.default.Component);

var AccordionNew = function (_React$Component2) {
    (0, _inherits3.default)(AccordionNew, _React$Component2);

    function AccordionNew(props) {
        (0, _classCallCheck3.default)(this, AccordionNew);

        var _this3 = (0, _possibleConstructorReturn3.default)(this, (AccordionNew.__proto__ || (0, _getPrototypeOf2.default)(AccordionNew)).call(this, props));

        _this3.handleChange = _this3.handleChange.bind(_this3);
        return _this3;
    }

    (0, _createClass3.default)(AccordionNew, [{
        key: "handleChange",
        value: function handleChange(expanded, sections) {

            sections = sections.map(function (item) {
                var _titleOrg = item._titleOrg,
                    other = (0, _objectWithoutProperties3.default)(item, ["_titleOrg"]);

                if (_titleOrg) {
                    other.title = _titleOrg;
                }
                return other;
            });

            typeof this.props.onChange == "function" && this.props.onChange(expanded, sections);
        }
    }, {
        key: "handleExtraClick",
        value: function handleExtraClick(e) {
            e.stopPropagation();
        }
    }, {
        key: "renderTitleWithExtra",
        value: function renderTitleWithExtra(title, extra) {
            return _react2.default.createElement(
                "span",
                { className: "cn-accordion-section-title-wrap" },
                _react2.default.createElement(
                    "span",
                    { className: "cn-accordion-section-title-title" },
                    title
                ),
                _react2.default.createElement(
                    "span",
                    { className: "cn-accordion-section-title-extra", onClick: this.handleExtraClick },
                    extra,
                    _react2.default.createElement("span", { className: "cn-accordion-section-title-extra-space" })
                )
            );
        }
    }, {
        key: "render",
        value: function render() {
            var _this4 = this;

            var _props = this.props,
                dataSource = _props.dataSource,
                extraRender = _props.extraRender,
                other = (0, _objectWithoutProperties3.default)(_props, ["dataSource", "extraRender"]);


            if (Array.isArray(dataSource)) {
                var dataSourceNew = dataSource.map(function (item) {
                    if (item.extra) {
                        var _other = (0, _objectWithoutProperties3.default)(item, []);

                        _other._titleOrg = item.title;
                        _other.title = _this4.renderTitleWithExtra(item.title, item.extra);
                        return _other;
                    } else if (extraRender) {
                        return (0, _extends3.default)({}, item, {
                            _titleOrg: item.title,
                            title: _this4.renderTitleWithExtra(item.title, extraRender(item))
                        });
                    } else {
                        return item;
                    }
                });
                other.dataSource = dataSourceNew;
            }

            return _react2.default.createElement(
                AccordionMonkey,
                (0, _extends3.default)({}, other, { onChange: this.handleChange }),
                _react2.default.Children.map(this.props.children, function (child) {
                    if (typeof child.props.extra == "undefined") {
                        return child;
                    } else {
                        var _child$props = child.props,
                            extra = _child$props.extra,
                            _other2 = (0, _objectWithoutProperties3.default)(_child$props, ["extra"]);

                        _other2.title = _this4.renderTitleWithExtra(child.props.title, child.props.extra);
                        return _react2.default.createElement(
                            Panel,
                            _other2,
                            child.props.children
                        );
                    }
                })
            );
        }
    }]);
    return AccordionNew;
}(_react2.default.Component);

exports.default = AccordionNew;


AccordionNew.Panel = Panel;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-accordion@0.0.1@@alicd/crui-accordion/lib/Accordion.js
// module id = 510
// module chunks = 0